import React, { FC, useState } from "react";
import { Helmet } from "react-helmet";
import SocialsList from "shared/SocialsList/SocialsList";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import toast from "react-hot-toast";
import { globalJson } from "global/global_json";
import { ContactFun } from "api/profile/profile";
import { Link } from "react-router-dom";
import RentalPolicies from "components/RentalPolicies/RentalPolicies";

export interface PageContactProps {
  className?: string;
}

const contacts = [
  {
    id: 1,
    icon: (
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.59345 1.28223L3.84456 0.531117C4.01049 0.489635 4.17715 0.510376 4.34456 0.593339C4.51049 0.676302 4.62456 0.791117 4.68678 0.937783L6.18678 4.43778C6.25049 4.60371 6.26086 4.76519 6.21789 4.92223C6.17641 5.07778 6.09345 5.20815 5.969 5.31334L4.09345 6.87556C4.65641 8.08297 5.41197 9.16593 6.36012 10.1245C7.30826 11.083 8.39641 11.8437 9.62456 12.4067L11.1557 10.5311C11.2609 10.3859 11.3964 10.2978 11.5623 10.2667C11.7297 10.2341 11.886 10.2496 12.0312 10.3133L15.5312 11.8133C15.6986 11.8756 15.8238 11.9896 15.9068 12.1556C15.9897 12.323 16.0105 12.4896 15.969 12.6556L15.2179 15.9067C15.1972 16.0933 15.1142 16.2393 14.969 16.3444C14.8223 16.4482 14.666 16.5 14.5001 16.5C11.8749 16.5 9.43715 15.8437 7.18678 14.5311C5.00012 13.2393 3.26086 11.5 1.969 9.31334C0.656412 7.06297 0.000117302 4.62519 0.000117302 2.00001C0.000117302 1.83408 0.0519676 1.67778 0.155672 1.53112C0.260857 1.38593 0.406783 1.30297 0.59345 1.28223Z"
          fill="#FBBE06"
        />
      </svg>
    ),
    title: "Phone Number",
    detail: (
      <>
        {globalJson.phone1}
        <br />
        {globalJson.phone2}
      </>
    ),
  },
  {
    id: 2,
    icon: (
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_2981_931)">
          <path
            d="M19.8901 4.73064L14.0254 10.5575L19.8901 16.3844C19.9961 16.1628 20.0604 15.9179 20.0604 15.6563V5.45878C20.0604 5.19715 19.9961 4.95222 19.8901 4.73064Z"
            fill="#FBBE06"
          />
          <path
            d="M18.3608 3.75941H2.42248C2.16085 3.75941 1.91592 3.82373 1.69434 3.92974L9.19 11.3877C9.85276 12.0504 10.9305 12.0504 11.5933 11.3877L19.089 3.92974C18.8674 3.82373 18.6224 3.75941 18.3608 3.75941Z"
            fill="#FBBE06"
          />
          <path
            d="M0.893481 4.73064C0.787464 4.95222 0.723145 5.19715 0.723145 5.45878V15.6563C0.723145 15.9179 0.787464 16.1629 0.893481 16.3844L6.75815 10.5575L0.893481 4.73064Z"
            fill="#FBBE06"
          />
          <path
            d="M13.2243 11.3589L12.3944 12.1888C11.2901 13.2931 9.49317 13.2931 8.38885 12.1888L7.559 11.3589L1.69434 17.1858C1.91592 17.2918 2.16085 17.3561 2.42248 17.3561H18.3608C18.6224 17.3561 18.8674 17.2918 19.089 17.1858L13.2243 11.3589Z"
            fill="#FBBE06"
          />
        </g>
        <defs>
          <clipPath id="clip0_2981_931">
            <rect
              width="19.3375"
              height="19.3375"
              fill="white"
              transform="translate(0.723145 0.888985)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    title: "Email",
    detail: globalJson.email,
  },
  {
    id: 3,
    icon: (
      <svg
        width="22"
        height="21"
        viewBox="0 0 22 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0.5C10.1345 0.5 9.33235 0.721243 8.59358 1.16373C7.85481 1.60621 7.26905 2.20514 6.8363 2.96051C6.40354 3.71588 6.18716 4.53606 6.18716 5.42103C6.18716 6.38375 6.76025 7.75009 7.90642 9.52003C8.64518 10.6401 9.52337 11.825 10.541 13.0747C10.6695 13.2321 10.8226 13.3108 11 13.3108C11.1774 13.3108 11.3305 13.2321 11.459 13.0747C12.4766 11.825 13.3548 10.6401 14.0936 9.52003C15.2398 7.75009 15.8128 6.38375 15.8128 5.42103C15.8128 4.53606 15.5965 3.71588 15.1637 2.96051C14.7309 2.20514 14.1452 1.60621 13.4064 1.16373C12.6677 0.721243 11.8655 0.5 11 0.5ZM11 7.06229C10.5672 7.06229 10.1915 6.89937 9.87284 6.57352C9.55416 6.24768 9.39481 5.86351 9.39481 5.42103C9.39481 4.97854 9.55416 4.59437 9.87284 4.26853C10.1915 3.94268 10.5672 3.77976 11 3.77976C11.4328 3.77976 11.8085 3.94268 12.1272 4.26853C12.4458 4.59437 12.6052 4.97854 12.6052 5.42103C12.6052 5.86351 12.4458 6.24768 12.1272 6.57352C11.8085 6.89937 11.4328 7.06229 11 7.06229ZM5.30988 7.06229L0.76321 8.93684C0.535062 9.04052 0.35037 9.19603 0.209136 9.40339C0.0697119 9.6126 0 9.8468 0 10.106V19.8703C0 20.0795 0.0887243 20.2489 0.266173 20.3785C0.445432 20.5081 0.636461 20.534 0.839259 20.4563L6.11111 17.9957V8.89518C5.7544 8.24534 5.48732 7.63438 5.30988 7.06229ZM11 14.5605C10.4405 14.5605 9.96971 14.3383 9.58765 13.894C8.74749 12.8535 7.99605 11.8519 7.33333 10.8891V17.9957L14.6667 20.4951V10.8891C14.004 11.8519 13.2525 12.8535 12.4123 13.894C12.0303 14.3383 11.5595 14.5605 11 14.5605ZM21.1607 6.78736L15.8889 9.24787V20.4951L21.2368 18.3096C21.4649 18.204 21.6496 18.0476 21.7909 17.8402C21.9303 17.631 22 17.3968 22 17.1376V7.37333C22 7.16597 21.9113 6.99657 21.7338 6.86512C21.5546 6.73552 21.3635 6.7096 21.1607 6.78736Z"
          fill="#FBBE06"
        />
      </svg>
    ),
    title: "Address",
    detail: globalJson.address,
  },
];

const PageContact: FC<PageContactProps> = ({ className = "" }) => {
  const [getEmail, setEmail] = useState("");
  const [newName, setNewName] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const sendEmail = async (e: React.FormEvent) => {
    setLoading(true);
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!getEmail.trim() || !emailRegex.test(getEmail)) {
      toast.error("Please enter a valid email address");
      setLoading(false);
      return;
    }

    if (getEmail.length === 0 || newName.length === 0 || message.length === 0) {
      toast.error("Fields are required!");
      setLoading(false);
      return;
    }

    // Create the payload with name, email, and message
    const companyPayload = {
      company:
        process.env.REACT_APP_ENV !== "prod"
          ? globalJson.dev_company_id
          : globalJson.prod_company_id,
      name: newName,
      email: getEmail,
      message: message,
    };
    const renterPayload = {
      company:
        process.env.REACT_APP_ENV !== "prod"
          ? globalJson.dev_company_id
          : globalJson.prod_company_id,
      name: newName,
      email: getEmail,
      message: message,
    };

    const result = await ContactFun(companyPayload);
    // const result1 = await ContactFun(renterPayload);

    if (result.error) {
      toast.error(result.error);
    } else {
      toast.success("Sent successfully!");
      setEmail("");
      setNewName("");
      setMessage("");
    }

    setLoading(false);
  };

  return (
    <div
      className={`nc-PageContact overflow-hidden ${className}`}
      data-nc-id="PageContact"
    >
      <div className="mb-24 lg:mb-32 mt-24">
        <div className="container mx-auto">
          <div className="flex-shrink-0 grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-12">
            <div className="mt-8 max-w-sm">
              <h2 className="text-4xl font-semibold">
                Don’t Hesitate to reach out
              </h2>

              <div className="flex flex-col mt-6">
                <div className=" space-y-6">
                  {contacts.map((contact) => (
                    <div className="border border-primary-100 px-4 py-2  rounded-md">
                      <p className="text-gray-500 text-sm">{contact.title}</p>
                      <div
                        key={contact.id}
                        className="flex items-center  space-x-4"
                      >
                        <div className="flex items-center justify-center w-12 h-12 ">
                          {contact.icon}
                        </div>

                        <div>
                          <p className="text-gray-900 text-lg font-semibold">
                            {contact.detail}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div>
              <div className="py-4"></div>
              <h2 className="text-bold text-4xl font-bold mb-4">
                Contact Us Now!
              </h2>
              <form className="grid grid-cols-1 gap-6" onSubmit={sendEmail}>
                <label className="block">
                  <Label>Full name</Label>
                  <Input
                    placeholder="Example Doe"
                    type="text"
                    className="mt-1"
                    value={newName}
                    onChange={(e) => {
                      setNewName(e.target.value);
                    }}
                  />
                </label>
                <label className="block">
                  <Label>Email address</Label>

                  <Input
                    type="email"
                    placeholder="example@example.com"
                    className="mt-1"
                    value={getEmail}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                  />
                </label>
                <label className="block">
                  <Label>Message</Label>

                  <Textarea
                    className="mt-1"
                    rows={6}
                    value={message}
                    onChange={(e) => {
                      setMessage(e.target.value);
                    }}
                  />
                </label>
                <div>
                  <ButtonPrimary type="submit" className="min-w-[200px]">
                    {loading ? (
                      <div className="flex justify-center items-center col-span-full">
                        <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-gray-300"></div>
                      </div>
                    ) : (
                      "Send Message"
                    )}
                  </ButtonPrimary>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="container relative py-16">
        <RentalPolicies />
      </div>
    </div>
  );
};

export default PageContact;
